import { NoWrap, numberFormat } from "../../../../utils/helpers";
import { INCIDENT_TICKET_CATEGORY_REPORT } from "../../../../utils/apis";

export const useIncidentTicketCategoryReport = () => {
  return {
    reportTitle: "Incident Ticket Category Report",

    customApi: () => INCIDENT_TICKET_CATEGORY_REPORT,

    tableData: (results: any[]) => {
      return results.map((item: any) => ({
        ...item,
        month_name: <NoWrap>{item.month_name || item.date}</NoWrap>,
        total_category: numberFormat(item.total_category || "0"),
      }));
    },

    tableColumns: () => [
      { id: "month_name", header: "Month" },
      { id: "category_name", header: "Category" },
      { id: "open_tickets", header: "Open Tickets" },
      { id: "closed_tickets", header: "Closed Tickets" },
      { id: "resolved_tickets", header: "Resolved Tickets" },
    ],

    graphData: (results: any[]) => {
      if (!results.length) return { xLabels: [], series: [], yLabel: "" };

      const xLabels = results.map(
        (item) => item.category_name || item.month_name || "",
      );
      const series = [
        {
          name: "Total Category",
          data: results.map((item) => Number(item.total_category || 0)),
        },
      ];

      return {
        xLabels,
        series,
        yLabel: "Total Category",
      };
    },

    externalFilters: [],

    initialFilters: {},

    exportData: {
      getEndpoint: () => `${INCIDENT_TICKET_CATEGORY_REPORT}export-to-csv`,
      fileName: "incident-ticket-category-report.xlsx",
      buttonText: "Export CSV",
    },

    showReportTypeFilter: false,
    showTotalTypeFilter: false,
    showMonthFilter: true,
    showYearFilter: true,
    defaultReportType: "monthly",
    defaultTotalType: undefined,
  };
};
